import React, { useState, useRef } from "react";
import JoditBaseEditor from "jodit-react";
import { useIsInvalid } from "@admin/components/FormErrorsContext";

export type Props = {
    initHtml?: string | undefined | null;
    label?: string;
    name: string;
    onBlur?: (value: string) => void;
};

export default function JoditEditor({ label, name, onBlur, initHtml = `` }: Props) {
    const editor = useRef(null);
    const [html, setHtml] = useState(initHtml || ``);
    const isInvalid = useIsInvalid(name);

    const changeValue = (data: string) => {
        setHtml(data);

        if (onBlur) {
            onBlur(data);
        }
    };

    return (
        <div className="mb-5">
            {label && <label className="form-label">{label}</label>}

            <JoditBaseEditor
                ref={editor}
                value={html}
                config={{
                    readonly: false,
                    placeholder: ``,
                    askBeforePasteFromWord: false,
                    askBeforePasteHTML: false,
                }}
                tabIndex={1}
                onBlur={changeValue}
                className={isInvalid ? ` is-invalid` : ``}
                name={name}
            />
        </div>
    );
}
